import React, { ComponentType, FC, ReactNode } from 'react';

import filterChildrenByType from '../../../utils/components/_filterChildrenByType';
import excludeChildrenByType from '../../../utils/components/_excludeChildrenByType';

import { StyledWrapper, StyledRowWrapper, StyledMessage, StyledIcon, StyledRow, StyledIconCol, StyledMessageCol, StyledActionCol } from './InlineMessage.styles';
import { Content, Action } from './InlineMessage.compounds';

export interface InlineMessageProps {
  /** Content of the message. */
  children?: ReactNode;
  /** Icon class to display to the left of the message. */
  Icon?: ComponentType;
  /** Color of the border and icon. */
  color?: string;
  /** Background of the message. */
  background?: string;
}

export type InlineMessageStatics = {
  Content: typeof Content;
  Action: typeof Action;
};

const InlineMessage: FC<InlineMessageProps> & InlineMessageStatics = ({ children, color, Icon, background, ...props }) => {
  const content = excludeChildrenByType(children, Action);
  const action = filterChildrenByType(children, Action);

  return (
    <StyledWrapper>
      <StyledMessage
        role="status"
        color={color}
        background={background}
        {...props}
      >
        <StyledRowWrapper>
          <StyledRow>
            {Icon && (
              <StyledIconCol>
                <StyledIcon as={Icon} color={color} />
              </StyledIconCol>
            )}
            <StyledMessageCol>
              {content.map((child, index) => <React.Fragment key={`${index}`}>{child}</React.Fragment>)}
            </StyledMessageCol>
          </StyledRow>
          {action.length ? <StyledActionCol>{action}</StyledActionCol> : null}
        </StyledRowWrapper>
      </StyledMessage>
    </StyledWrapper>
  );
};

InlineMessage.Content = Content;
InlineMessage.Action = Action;

export default InlineMessage;
